import { BundleBuilderStoreMixinComponent } from '@theme/bundle-builder-mixin-store';

/** @typedef {import('./bundle-builder-store.js').Product} Product */
/** @typedef {import('./bundle-builder-store.js').BundleItem} BundleItem */
/** @typedef {Record<string, import('./bundle-builder-mixin.js').BundleBuilderPropSpec>} BundleBuilderProps */

export class BundleBuilderSummaryItemComponent extends BundleBuilderStoreMixinComponent {
  requiredRefs = [
    'image',
    'imageWrapper',
    'title',
    'removeButton',
    'comparePrice',
    'price',
  ];

  /** @type {BundleBuilderProps} */
  props = {
    productId: {
      type: 'number',
      required: true,
      attributeName: 'data-product-id',
    },
  };

  /** @type {number} */
  productId;

  /** @type {Product|undefined} */
  product;

  connectedCallback() {
    super.connectedCallback();
    this.product = this.getters.getProduct(this.productId);
  }

  /** @returns {BundleItem|undefined} */
  get bundleItem() {
    return this.state.items.find((item) => item.productId === this.productId);
  }

  handleRemove() {
    this.mutations.removeItemFromBundle(this.productId);
  }

  onStateUpdate() {
    const item = this.bundleItem;
    if (!item) return;

    const product = this.getters.getProduct(this.productId);
    const { formatMoney } = this.getters;
    const productTitle = product?.title ?? '';

    const image = /** @type {HTMLImageElement} */ (this.refs.image);
    image.src = product?.image ?? '';
    image.alt = productTitle;

    const backgroundColor = this.getters.getBackgroundColor(this.productId);
    const imageWrapper = /** @type {HTMLElement} */ (this.refs.imageWrapper);
    if (backgroundColor) {
      imageWrapper.style.setProperty('--bb-card-bg', backgroundColor);
    } else {
      imageWrapper.style.removeProperty('--bb-card-bg');
    }

    /** @type {HTMLElement} */ (this.refs.title).textContent = productTitle;

    const compare = /** @type {HTMLElement} */ (this.refs.comparePrice);
    const showCompare = item.basePrice > item.price;
    compare.textContent = formatMoney(item.basePrice * item.quantity);
    compare.hidden = !showCompare;

    /** @type {HTMLElement} */ (this.refs.price).textContent = formatMoney(item.price * item.quantity);
  }
}

if (!customElements.get('bundle-builder-summary-item-component')) {
  customElements.define(
    'bundle-builder-summary-item-component',
    BundleBuilderSummaryItemComponent
  );
}
